import { useEffect as a } from "react";
import { t as l } from "./index.es106.js";
import { VariableState as c } from "./index.es137.js";

var u = function u(r, e, o) {
  var t = function t() {
    if (!r.current) return;
    var i = Array.from(r.current.children).filter(function (n) {
      return n.hasAttribute(c.error);
    });
    return o === null || o === void 0 ? void 0 : o(i.length ? l("component_component_variableError_invalidFormatLabel") : "");
  };

  return a(function () {
    t();
  }, [JSON.stringify(e)]), {
    validateErrors: t
  };
};

export { u as useValidation };